import { useEffect, useState } from "react";
import "../styles/Coberturas.css";
import CoberturasCards from "./CoberturasCards";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { ButtonNext, ButtonPrevious } from "../../../../assets/icons/Icons";

const Coberturas = ({ coberturas, coberturasDesc }) => {
  const [cobertura, setCobertura] = useState();

  const responsive = {
    320: {
      items: 1,
    },
    576: {
      items: 1,
    },
    768: {
      items: 1,
    },
    1024: {
      items: 2,
    },
    1200: {
      items: 3,
    },
    1400: {
      items: 3,
    },
    1600: {
      items: 3,
    },
    1800: {
      items: 3,
    },
  };

  const onSlideChangedCobertura = (e) => {
    if (e.isNextSlideDisabled) {
      document.getElementsByClassName(
        "btn__next__coberturas"
      )[0].style.display = "none";
      document.getElementsByClassName(
        "btn__prev__coberturas"
      )[0].style.display = "block";
    } else if (e.isPrevSlideDisabled) {
      document.getElementsByClassName(
        "btn__prev__coberturas"
      )[0].style.display = "none";
      document.getElementsByClassName(
        "btn__next__coberturas"
      )[0].style.display = "block";
    } else {
      document.getElementsByClassName(
        "btn__next__coberturas"
      )[0].style.display = "block";
      document.getElementsByClassName(
        "btn__prev__coberturas"
      )[0].style.display = "block";
    }
  };

  useEffect(() => {
    if (coberturas?.length < 1 || coberturas === undefined) return;
    let arregloCobertura = [];
    coberturas.forEach((element) => {
      let arregloDescripcionesCobertura = [];
      coberturasDesc.forEach((desc) => {
        if (desc.idCobertura === element.id) {
          arregloDescripcionesCobertura.push(desc);
        }
      });
      arregloCobertura.push(
        <CoberturasCards
          cobertura={element}
          coberturasDesc={arregloDescripcionesCobertura}
        />
      );
    });
    setCobertura(arregloCobertura);
  }, [coberturas, coberturasDesc]);

  return (
    <>
      <div id="coberturas">
        <div
          className="homeout__coberturas container mt-lg-5 pt-lg-5"
          style={{ paddingBottom: "3rem" }}
        >
          <h2 style={{ color: "var(--rojo)", marginTop: "2rem" }}>
            ¿Cómo te protege tu seguro?
          </h2>
          <p style={{ paddingBottom: "2.5rem", fontSize: "1.5rem" }}>
            Haz clic en “Conoce más” para consultar los detalles de cada una de
            las coberturas
          </p>
          <div className="div__carousel__coberturas">
            {cobertura?.length > 0 && (
              <AliceCarousel
                items={cobertura}
                responsive={responsive}
                centerMode={true}
                disableDotsControls
                onSlideChanged={onSlideChangedCobertura}
                renderPrevButton={() => {
                  return (
                    <div className="btn__prev__coberturas">
                      <ButtonPrevious />
                    </div>
                  );
                }}
                renderNextButton={() => {
                  return (
                    <div className="btn__next__coberturas">
                      <ButtonNext />
                    </div>
                  );
                }}
              />
            )}
          </div>
          {/* <CoberturasCards coberturas={coberturas} coberturasDesc={coberturasDesc} /> */}
        </div>
      </div>
    </>
  );
};

export default Coberturas;
